export enum ClientType {
  Individual = 1,
  Business = 2,
}

export enum ClientGender {
  male = 1,
  female = 2,
  other = 0,
}

export enum ClientValidationStatus {
  unknown = 0,
  valid = 1,
  invalid = 2,
  incomplete = 3,
  outOfDate = 4,
}

export enum ClientAddressType {
  residential = 3,
  postal = 2,
  business = 1,
}

export enum ClientTaxStatus {
  unknown = 0,
  NaturalPerson = 1,
  partner = 2,
  company = 3,
  nonTaxable = 4,
  naturalPersonForTrust = 5,
  companyForTrust = 6,
  nonTaxableForTrust = 7,
}

export enum ClientIDNumberTypes {
  unknown = 0,
  southAfrica = 1,
  namibia = 2,
  passport = 3,
}

export interface BaseRoleplayer {
  id: number;
  addresses: Address[];
  parties: Party[];
  agentID: number;
  brokerCode: string;
  roleplayerID: number;
  roleplayerName: string;
  created: string;
  idNumber?: string;
  idNumberTypeID?: number;
  idNumberTypeNote?: string;
  regNumber?: string;
  taxStatusID: ClientTaxStatus;
  taxStatusNote: string;
  taxStatusName: string;
  typeID: ClientType;
  typeNote: string;
  typeName: string;
  stateID: number;
  stateName: string;
  stateNote: string;
  kycStatusID: number;
  kycStatusName: string;
  kycStatusNote: string;
  uid: string;
  updated: string;
  validationStatusID: ClientValidationStatus;
  validationStatusName: string;
  validationStatusNote: string;
}

export interface Address {
  id: number;
  roleplayerID: number;
  street: string;
  city: string;
  province: string;
  country: string;
  code: string;
  typeID: ClientAddressType;
  typeName: string;
  typeNote: string;
}

export interface Party {
  id: number;
  roleplayerID: number;
  partyRoleplayerID: number;
  relationshipID: number;
  relationshipName: string;
  relationshipNote: string;
  roleplayerTypeID: ClientType;
  roleplayerTypeNote: string;
  roleplayerTaxStatusID: number;
  roleplayerTaxStatusNote: string;
  roleplayerName: string;
  roleplayerIDReg: string;
  roleplayerDOBEst: string;
  partyRoleplayerTypeID: number;
  partyRoleplayerTypeNote: string;
  partyRoleplayerTaxStatusID: number;
  partyRoleplayerTaxStatusNote: string;
  partyRoleplayerName: string;
  partyRoleplayerIDReg: string;
  partyRoleplayerDOBEst: string;
  representativeRoleplayerID: number;
  representativeRoleplayerTypeID: ClientType;
  representativeRoleplayerTypeNote: string;
  representativeRoleplayerTaxStatusID: number;
  representativeRoleplayerTaxStatusNote: string;
  representativeRoleplayerName: string;
  representativeRoleplayerIDReg: string;
  representativeRoleplayerDOBEst: string;
  representativePartyRoleplayerTypeID: number;
  representativePartyRoleplayerTypeNote: string;
  representativePartyRoleplayerTaxStatusID: number;
  representativePartyRoleplayerTaxStatusNote: string;
  representativePartyRoleplayerName: string;
  representativePartyRoleplayerIDReg: string;
  representativePartyRoleplayerDOBEst: string;
}

interface Emails {
  id: number;
  roleplayerID?: number;
  address: string;
}

interface Phones {
  id: number;
  roleplayerID?: number;
  number: string;
}

export interface NaturalPerson extends BaseRoleplayer {
  activeDayzID: number;
  activeDayzName: string;
  activeDayzNote: string;
  idNumber: string;
  passport: string;
  idNumberTypeID: ClientIDNumberTypes;
  idNumberTypeNote: string;
  roleplayerIDReg: string;
  dateOfBirth: string;
  educationID: number;
  educationName: string;
  educationNote: string;
  emails: Emails[];
  firstname: string;
  fitnessLevelID: number;
  fitnessLevelName: string;
  fitnessLevelNote: string;
  genderID: ClientGender;
  genderName: string;
  genderNote: string;
  height: number;
  income: number;
  incomplete: boolean;
  interactiveID: number;
  interactiveName: string;
  interactiveNote: string;
  mandated: boolean;
  maritalStatusID: number;
  maritalStatusName: string;
  maritalStatusNote: string;
  middlename: string;
  bmi: number;
  IsMomentumInteractive: boolean;
  multiplyMembershipID: number;
  multiplyMembershipName: string;
  multiplyMembershipNote: string;
  multiplyStatusID: number;
  multiplyStatusName: string;
  multiplyStatusNote: string;
  occupationID: number;
  occupationName: string;
  occupationNote: string;
  passportID: boolean;
  personDetailID: number;
  phones: Phones[];
  selfemployed: boolean;
  spouseEducationID: number;
  spouseEducationName: string;
  spouseEducationNote: string;
  spouseOccupationID: number;
  spouseOccupationName: string;
  spouseOccupationNote: string;
  spouseIncome: number;
  spouseFirstname: string;
  spousePreviousSurname: string;
  spouseIsSelfEmployed: boolean;
  spouseName: string;
  spouseSurname: string;
  surname: string;
  previousSurname?: string;
  titleID: number;
  titleName: string;
  titleNote: string;
  tobacco: boolean;
  weight: number;
}

interface Contact {
  id: number;
  roleplayerID: number;
  firstname: string;
  surname: string;
  phone: string;
  email: string;
}

export interface Valuation {
  id: number;
  roleplayerID: number;
  value: number;
  methodID: number;
  methodName: string;
  methodNote: string;
  basisID: number;
  basisName: string;
  basisNote: string;
}

export interface LegalEntity extends BaseRoleplayer {
  contacts: Contact[];
  dateEstablished: string;
  regNumber: string;
  incomplete: boolean;
  language: string;
  legalDetailID: number;
  legalname: string;
  mandated: boolean;
  taxNumber: string;
  vatNumber: string;
  valuation?: Valuation;
  valuationID: number;
}
